import React from 'react';

const CHEVRON_STROKE = {
  stroke: 'currentColor' as const,
  strokeWidth: 2.25,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

/** Points down; inherits color via `currentColor`. */
export const ChevronDownIcon: React.FC<{ className?: string }> = ({
  className = '',
}) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M6 9l6 6 6-6" {...CHEVRON_STROKE} />
  </svg>
);

/** Points up; inherits color via `currentColor`. */
export const ChevronUpIcon: React.FC<{ className?: string }> = ({
  className = '',
}) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M6 15l6-6 6 6" {...CHEVRON_STROKE} />
  </svg>
);
